import { media } from "@features/adaptive/breakpoints";
import { Typography } from "@packages/uiKit";
import Image from "next/image";
import styled from "styled-components";

export const StyledArticleCard = styled.div`
  display: flex;
  flex-direction: column;
  height: 290px;

  ${media.down("tablet")} {
    height: auto;
  }
`;

export const StyledImage = styled(Image).attrs({ width: 451, height: 170 })`
  width: 100%;
  height: 170px;

  object-fit: cover;
  border-radius: 18px;

  ${media.down("tablet")} {
    height: 130px;
  }
`;

export const StyledInfo = styled.div`
  flex: 1;
  width: calc(100% - 45px);
  padding-bottom: 19px;
  border-bottom: 1px solid #e8eaec;
  display: flex;

  flex-direction: column;
  justify-content: space-between;
  ${media.down("desktop")} {
    width: 100%;
  }
`;

export const StyledTitle = styled(Typography).attrs({
  size: 22,
  weight: 700,
  color: "dark",
})`
  margin-top: 18px;
`;

export const StyledDate = styled(Typography).attrs({
  size: 12,
  weight: 400,
  color: "gray3",
})`
  margin-top: 13px;
`;
